import { Navigation } from '@adminhub/reactive-vars';

export const useMainLayoutRightSidebar = () =>
	({
		showSidebar(): void {
			Navigation.reactiveVariables.showRightSidebarContainer(true);
		},

		hideSidebar(): void {
			Navigation.reactiveVariables.showRightSidebarContainer(false);
		},
		setExpanded(expanded: boolean): void {
			Navigation.reactiveVariables.isRightSidebarExpanded(expanded);
		},
	}) as const;
